export default {
    content: {
        display: 'flex',
        flexDirection: 'row',
        gap: '15px',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        paddingBottom: '20px',
        '@media(min-width:801px)': {
            justifyContent: 'flex-end',
            alignItems: 'center',
            paddingBottom: 'unset',
        }
    },
    defaultStyle: {
        margin: '0px auto',
        maxWidth: '1170px',
    },
    filterName:{},
    activeFilter:{
        border: 'none',
        display: 'flex',
        padding: '0',
        borderRadius: '20px',
        backgroundColor: ' #F3F2EF',
        cursor: 'default',
        '& $filterName':{
            font: "300 13px 'Roboto', sans-serif",
            color: data => data.mainColor,
            padding: '8px 0 8px 18px'
        }
    },
    closeButton:{
        color: data => data.mainColor,
        fontSize: '10px',
        padding: '8px 18px 8px 10px'
    },
    tooltipStyle: {
        textAlign: 'center',
        position: 'absolute',
        maxWidth: '220px',
        display: 'table',
        backgroundColor: '#fff',
        font: "11px 'Roboto',sans-serif",
        color: '#000',
        padding: '20px 9px',
        zIndex: '700',
        border: '1px solid #D8D8D8',
        '@media (max-width:600px)': {
            paddingTop: '25px'
        },
        '& span:nth-of-type(2)':{
            fontSize: '10px'
        }
    },
    popoverStyle: {
        height: '10%',
        width: '10%'
    },
    tooltipPointerStyle: {
        backgroundColor: '#fff',
        width: '10px',
        height: '10px',
        borderBottom: '1px solid #d8d8d8',
        borderLeft: '1px solid #d8d8d8'
    },
    containerFiltersActive:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
        '@media(min-width:801px)': {
            flexDirection: 'row',
            gap: '15px',
        }
    },
    clearFiltersBtn:{},
    clearFilters: {
        '& $clearFiltersBtn':{
            padding: '8px 0',
            '& $clearFiltersText':{
                padding: '8px 0',
                PointerEvent: 'auto',
            }
        }
    },
};